import { container } from "gatsby-theme-docz/src/components/MainContainer/styles";

container.maxWidth = 1100;

export default container;
